import React, { useState } from 'react';
import { Accordion } from './Accordion';
export function Bonos() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const bonos = [{
    num: '01',
    icon: '🗺️',
    title: 'Mapa de las Primeras 100 Señas',
    price: '$8.000',
    desc: 'Las 100 señas más urgentes organizadas por situación — familia, trabajo y calle.',
    result: 'Tus alumnos nuevos saben exactamente por dónde empezar desde el día uno.'
  }, {
    num: '02',
    icon: '✅',
    title: 'Planificación de Clases 30 Días',
    price: '$7.000',
    desc: '30 clases estructuradas con tema, objetivo, señas y actividad lista para cada día.',
    result: 'Nunca más llegás a una clase sin saber qué dar.'
  }, {
    num: '03',
    icon: '💬',
    title: '80 Frases para Situaciones Reales',
    price: '$9.000',
    desc: '80 frases organizadas por situación para usar como ejercicio de conversación en el aula.',
    result: 'Tus alumnos practican conversación real desde las primeras clases.'
  }, {
    num: '04',
    icon: '📊',
    title: 'Tracker de Progreso del Alumno',
    price: '$8.000',
    desc: 'Sistema visual para registrar el avance de cada alumno clase por clase.',
    result: 'Sabés exactamente en qué nivel está cada alumno y qué necesita reforzar.'
  }, {
    num: '05',
    icon: '🃏',
    title: 'Flashcards Digitales de Repaso',
    price: '$9.000',
    desc: '200 tarjetas digitales organizadas por nivel para repasar al inicio o cierre de cada clase.',
    result: 'Tus alumnos repasan solos entre clase y clase sin que vos tengas que preparar nada extra.'
  }, {
    num: '06',
    icon: '📋',
    title: 'Guía de Expresiones Faciales del LSA',
    price: '$7.000',
    desc: 'Guía completa de expresión facial gramatical y emocional con ejemplos y ejercicios para el aula.',
    result: 'Enseñás la parte más difícil del LSA de forma clara, visual y sin improvisación.'
  }];
  return <section className="bg-lsa-light text-lsa-dark py-12 px-5" data-id="element-26">
      <div className="max-w-xl mx-auto" data-id="element-27">
        <div className="flex justify-center mb-5" data-id="element-28">
          <span className="inline-flex items-center gap-2 bg-green-100 text-green-700 rounded-full px-4 py-1.5 text-xs font-bold tracking-wide" data-id="element-29">
            🎁 Bonos de regalo
          </span>
        </div>

        <h2 className="text-[28px] font-extrabold text-center mb-3 leading-tight" data-id="element-30">
          6 bonos incluidos.{' '}
          <span className="text-green-600" data-id="element-31">Gratis. Siempre.</span>
        </h2>
        <p className="text-center text-lsa-dark/70 text-[16px] font-medium mb-10" data-id="element-32">
          Valor total:{' '}
          <span className="line-through text-lsa-dark/40" data-id="element-33">$48.000 ARS</span> →{' '}
          <span className="font-extrabold text-green-600" data-id="element-34">
            $0 con tu sistema.
          </span>
        </p>

        <div data-id="element-35">
          {bonos.map((bono, index) => <Accordion key={index} theme="light" isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? -1 : index)} title={<div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3" data-id="element-37">
                  <div className="flex items-center gap-2" data-id="element-38">
                    <span className="font-bold text-lsa-celeste text-sm" data-id="element-39">
                      BONO {bono.num}
                    </span>
                    <span className="hidden sm:inline text-lsa-dark/20" data-id="element-40">—</span>
                    <span className="text-xl" data-id="element-41">{bono.icon}</span>
                  </div>
                  <div className="flex-1 flex flex-col sm:flex-row sm:items-center justify-between gap-1 sm:gap-4" data-id="element-42">
                    <span className="font-bold" data-id="element-43">{bono.title}</span>
                    <div className="flex items-center gap-2 text-sm" data-id="element-44">
                      <span className="line-through text-lsa-dark/40" data-id="element-45">
                        {bono.price}
                      </span>
                      <span className="bg-green-600 text-white px-2 py-0.5 rounded text-xs font-bold tracking-wide" data-id="element-46">
                        GRATIS
                      </span>
                    </div>
                  </div>
                </div>} data-id="element-36">
              <div className="pt-2 pb-1 space-y-3" data-id="element-47">
                <p className="text-[14px] leading-relaxed text-lsa-dark/80" data-id="element-48">
                  {bono.desc}
                </p>
                <p className="italic text-[14px] leading-relaxed text-lsa-dark/90 border-l-2 border-lsa-celeste pl-3" data-id="element-49">
                  <span className="font-semibold text-lsa-celeste not-italic" data-id="element-50">
                    Resultado:{' '}
                  </span>
                  {bono.result}
                </p>
              </div>
            </Accordion>)}
        </div>
      </div>
    </section>;
}